import { SonarTagDisplay } from '@ui/tags';
import { When } from 'react-if';
import { Button, Menu } from 'antd';
import { COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React, { useMemo } from 'react';
import { SearchOptionGroup } from './DataDictionarySearch';
import { useBoolean, useTags } from '@hooks';
const tagItemsGroup = {
    key: 'title',
    label: COPY_SPECIFIC.TAGS,
    type: 'group'
};
export const QuickAccessTags = ({ onSelect }) => {
    const [showAllTags, setShowAllTags] = useBoolean(false);
    const tags = useTags();
    const tagItems = useMemo(() => [Object.assign(Object.assign({}, tagItemsGroup), { children: (showAllTags ? tags : tags.slice(0, 10))
                .map(({ id }) => ({
                group: SearchOptionGroup.Tag,
                key: String(id),
                label: React.createElement(SonarTagDisplay, { noClick: true, tagId: id }),
                value: id
            })) })], [showAllTags, tags]);
    return (React.createElement("div", null,
        React.createElement(Menu, { className: 'quick-access-menu', items: tagItems, mode: 'inline', onClick: (info) => {
                onSelect(Number(info.key));
            } }),
        React.createElement(When, { condition: tags.length > 10 },
            React.createElement(Button, { className: 'show-all', onClick: setShowAllTags.toggle, type: 'link' }, showAllTags ? COPY_GENERIC.SHOW_LESS : COPY_GENERIC.SHOW_ALL))));
};
